var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4354_80265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6 29.67C15.31 29.67 15.04 29.55 14.85 29.33C14.49 28.92 6 19.27 6 12.8C6 7.95004 9.3 3.04004 15.6 3.04004C21.9 3.04004 25.24 8.00004 25.24 12.8C25.24 18.94 16.72 28.9 16.36 29.32C16.17 29.54 15.9 29.67 15.61 29.67H15.6ZM15.6 5.04004C10.61 5.04004 8 8.95004 8 12.8C8 17.47 13.53 24.62 15.59 27.11C17.65 24.56 23.24 17.23 23.24 12.8C23.24 8.98004 20.38 5.04004 15.6 5.04004Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.42 17.6404C15.42 17.6404 15.38 17.6404 15.37 17.6404C14.17 17.5804 13.04 17.0704 12.18 16.2204C11.26 15.3004 10.75 14.0804 10.75 12.7804C10.75 11.4804 11.26 10.2504 12.18 9.33039C13.09 8.41039 14.32 7.90039 15.62 7.90039C16.92 7.90039 18.15 8.41039 19.06 9.33039C19.52 9.79039 19.87 10.3104 20.1 10.8704C20.31 11.3804 20.07 11.9704 19.56 12.1804C19.05 12.3904 18.47 12.1504 18.25 11.6404C18.12 11.3204 17.91 11.0204 17.64 10.7504C16.56 9.66039 14.67 9.66039 13.59 10.7504C13.04 11.2904 12.74 12.0104 12.74 12.7804C12.74 13.5504 13.04 14.2704 13.58 14.8104C14.1 15.3204 14.75 15.6204 15.46 15.6504C16.01 15.6804 16.44 16.1504 16.41 16.7004C16.38 17.2304 15.94 17.6504 15.41 17.6504L15.42 17.6404Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9601 22.1401C16.5289 22.1401 16.9901 21.6789 16.9901 21.1101C16.9901 20.5412 16.5289 20.0801 15.9601 20.0801C15.3912 20.0801 14.9301 20.5412 14.9301 21.1101C14.9301 21.6789 15.3912 22.1401 15.9601 22.1401Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 29.6698C6.80001 29.6698 6.60001 29.6098 6.43001 29.4898C5.98001 29.1698 5.87001 28.5498 6.18001 28.0998L24.14 2.42976C24.46 1.97976 25.08 1.86976 25.53 2.17976C25.98 2.49976 26.09 3.11976 25.78 3.56976L7.82001 29.2398C7.63001 29.5198 7.32001 29.6698 7.00001 29.6698Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4354_80265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.96,
    height: 27.67,
    fill: "white",
    transform: "translate(6 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOff);
export default __webpack_public_path__ + "static/media/LocationOff.bfca7fee.svg";
export { ForwardRef as ReactComponent };